/**
 * Public pages that live outside the auth gate and the route table: the router skips its auth
 * redirect + 404 logic for them. The shared-ET pages (/s/:token), the logged-out marketing pages
 * we send people to (/flagship = R, /plugin = S, /app), the legal pages, the Claude / ChatGPT
 * guide (/ai) and the phone flows on the web (/m).
 *
 * A page added to router.jsx's public <Route>s MUST be added here too, or every visitor is
 * bounced to the 404 page: /ai shipped without it on 2026-10-13 and showed "Oops" for two days.
 *
 * Match with any trailing slash stripped. The router's 404 check normalises paths by ADDING a
 * slash, so "/flagship/" once missed an exact-match guard, failed the routeConfig lookup, and
 * bounced the visitor to the 404 page. Links in the wild carry trailing slashes.
 */
const PUBLIC_EXACT = [
  "/flagship", "/plugin", "/simple", "/w", "/x", "/y", "/z", "/get", "/app",
  "/privacy", "/terms", "/ai", "/delete-account", "/m",
];
const PUBLIC_PREFIXES = ["/s/", "/m/"];

export function isPublicPage(pathname) {
  const bare = pathname.replace(/\/+$/, "") || "/";
  return PUBLIC_EXACT.includes(bare) || PUBLIC_PREFIXES.some((p) => bare.startsWith(p));
}
